import { t } from 'ttag'

import {
  TAB_NAMES as REPORT_TAB_NAMES,
  getFactors,
} from 'components/modals/TestsReportModal/model'

/** Main modal tabs (distinct from REPORT_TAB_NAMES.OVERVIEW used inside PersonalityFactors). */
export const TAB_NAMES = {
  OVERVIEW: 'jobseeker-results-overview',
  PERSONALITY: REPORT_TAB_NAMES.PERSONALITY,
}

export const getTabs = () => [
  { id: TAB_NAMES.OVERVIEW, label: t`Talent overview` },
  { id: TAB_NAMES.PERSONALITY, label: t`Personality` },
]

/** Same factor list as a single recruitment candidate, with job-seeker neuroticism facet. */
export const getJobSeekerPersonalityFactors = () =>
  getFactors(true, true).filter(
    ({ parentId }) => parentId === REPORT_TAB_NAMES.PERSONALITY,
  )

/**
 * Label for one algorithm version's tab.
 *
 * The current result is named for what it is; an older one is named by the date it was
 * produced, because its version string ("unknown-pre-2026.09") is an admission rather than
 * a name — nothing recorded which algorithm produced results from before version stamping.
 */
export const scoreRunLabel = (run, language = 'en') => {
  if (run.is_primary) {
    return t`Current algorithm`
  }
  const date = new Date(run.calculated_at)
  if (Number.isNaN(date.getTime())) {
    return t`Earlier result`
  }
  const locale = language === 'nb' ? 'nb-NO' : undefined
  const formattedDate = date.toLocaleDateString(locale)
  return t`Result from ${formattedDate}`
}

/** Older results are shown as recorded: we cannot reproduce them, so we do not imply we can. */
export const isReproducible = run => run.is_reproducible === true
